import React from 'react';
import { NavLink } from 'react-router-dom';
import { CustomerDataIcon } from '../Icons';

const CustomerData = props => {
  return (
    <li className="nav-item">
      <NavLink
        onClick={props.onClick}
        to={props.link}
        activeClassName="active"
        className="vertical-nav-hover nav-link text-dark rounded-lg text-decoration-none"
      >
        <CustomerDataIcon fill="#212121" />
        Admin
      </NavLink>
    </li>
  );
};
export default CustomerData;
